'use client';

import { createFormAttributionHandler, createFormSubmissionHandler } from '../core';
import { FC } from 'react';
import { FormAttributionInteraction } from '../types';
import { useUtag } from '../hooks';
export const TrackFormAttribution: FC = () => {
  useUtag(() => {
    let handleChange = createFormAttributionHandler(FormAttributionInteraction.Fill);
    let handleSubmit = createFormSubmissionHandler();
    document.addEventListener('change', handleChange);
    document.addEventListener('submit', handleSubmit);
    return () => {
      document.removeEventListener('change', handleChange);
      document.removeEventListener('submit', handleSubmit);
    };
  }, []);
  return null;
};